import { Col, Row } from 'antd'
import React from 'react'
import Button from '../../../../../components/FormElements/Button'
import DynamicForm from '../../../../../components/FormElements/DynamicForm'
import * as Yup from 'yup'
import Dragger from 'antd/es/upload/Dragger'
import { message, Upload } from 'antd';
import { FaIdCard } from "react-icons/fa";


const BusinessInfoForm = () => {
    const form = {
        name: 'bookingForm',
        formFields: [
            {
                name: 'condition1',
                type: 'checkbox',
                label: 'I confirm that all the business information provided is accurate and up to date.',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null,
            },
            {
                name: 'condition2',
                type: 'checkbox',
                label: 'I have read and understand the terms and conditions of Mobrage and agree to abide by them.',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null,
            },
            {
                name: 'condition3',
                type: 'checkbox',
                label: 'I acknowledge that any inaccuracies in my business information may result in the suspension or removal of my profile from Mobrage.',
                width: { md: 24, sm: 24, xs: 24 },
                component: null,
                classes: '',
                icon: null,
            },
        ],
        formValidation: {
            condition1: Yup.boolean()
                .oneOf([true], 'You must accept the terms and conditions')
                .required('You must accept the terms and conditions'), // Optional, to explicitly mark it as required
            condition2: Yup.boolean()
                .oneOf([true], 'You must accept the terms and conditions')
                .required('You must accept the terms and conditions'),
            condition3: Yup.boolean()
                .oneOf([true], 'You must accept the terms and conditions')
                .required('You must accept the terms and conditions'),
        }
    }

    const handleSubmit = (values) => {
        console.log(values)
    }

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const dropzoneProps = {
        name: 'file',
        multiple: true,
        action: '',
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <Row>
            <Col
                md={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                xs={{ span: 24, offset: 0 }}
                className='md:p-4 sm:p-4 p-2'
            >
                <div className='mb-2 text-center flex flex-col items-center'>
                    <h6 className='heading-6 font-bold mb-3'>Proof of Business</h6>
                    <div className='md:w-2/5 sm:w-2/5 mb-2 bg-[#f3f6f8]'>
                        <Dragger {...dropzoneProps}>
                            <div className='py-2 px-4' >
                                <div className="flex justify-center ant-upload-drag-icon mb-4">
                                    <FaIdCard className='text-3xl text-slate-400'/>
                                </div>
                                <h6 className="heading-6 text-xs text-gray-400 ant-upload-text">Business/Trade Insurance</h6>
                            </div>
                        </Dragger>
                    </div>
                </div>
                <div>
                    <DynamicForm form={form} onSubmit={handleSubmit} />
                    <Button.Basic
                        onClick={submitForm}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Save'
                        className='btn-primary md:w-fit sm:w-fit w-full'
                    />
                </div>
            </Col>
        </Row>
    )
}

export default BusinessInfoForm